import styled from "@emotion/styled";

export const Heading = styled.h1`
	font-size: 28px;
	font-weight: bold;
	margin-bottom: 0px;
`;
